var simpatico_monitor = true;
var partnerReferralLink = "";
var blush_partnerID = "";
var partnerQueryString = "";
var arr_pids = [];
var meet_shop = "MEET";
jQuery(document).ready(function() {  
    var partnerTitleVariable = jQuery("#\\#_gh_variable_partner_title").text();
    var partnerNameVariable = jQuery("#\\#_gh_variable_partner_name").text();
    var partnerBioVariable = jQuery("#\\#_gh_variable_partner_bio").text();
    var partnerPictureVariable = jQuery("#\\#_gh_variable_partner_picture").text();
    var partnerReferralLink = jQuery("#\\#_gh_variable_partner_referral_link").text();
    var partnerID = jQuery("#\\#_gh_variable_partner_id").text();
  	var sealImage = "";
    var partnerBioHeaderText = "";

    jQuery('#partner_title').text(partnerTitleVariable);
    //jQuery('#gh_partner-name').text(partnerNameVariable);
    //jQuery('#gh_partner-img').attr("src",partnerPictureVariable);

  //Get GrowthHero Partner data
  //console.log( 'url: https://blushington.com/apps/rt/gh_partner.php?sl='+partnerID );
  var request = new XMLHttpRequest();
    request.open('GET', 'https://blushington.com/apps/rt/gh_partner.php?sl='+partnerID);
    request.setRequestHeader("X-Shopify-Access-Token", "56ac72b69c767199c78a246b21f51ce0");
    request.onreadystatechange = function () {
      if (this.readyState === 4) {
        partner = JSON.parse(this.responseText);
        //console.log('partner:', partner);
        if (partner['groupId']=="8022") {
          meet_shop = "SHOP";
          //jQuery( ".shop_my" ).html("Our");
          //jQuery( ".shop_me" ).html("Us");
          if (typeof partner["additionalFields"]["website"] !== 'undefined' && partner["additionalFields"]["website"] != ""){ 
            jQuery( "#blo-website-button a" ).attr("href",partner["additionalFields"]["website"] );
            jQuery( "#blo-website-button a" ).html("BOOK AN APPOINTMENT AT "+ partnerTitleVariable);
            jQuery( "#blo-website-button" ).removeClass("hide");
            jQuery( "#shop-collection-button-bottom" ).addClass("hide");
            
          } 

        }
        setShopWithMeCookie(partnerID, partnerPictureVariable);
        partnerQueryString = '?ghref='+ partner['groupId'] +':'+partnerID;
  		jQuery('#partner_link').attr('href', '/pages/'+ partner["additionalFields"]["shortLink"] +'?ghref='+ partner['groupId'] +':'+partnerID+'&ghmodalname='+partner['firstName']+'%20'+partner['lastName']);
        jQuery('#partner_link').attr('data-link', partner["additionalFields"]["shortLink"]);

        jQuery('#_gh_partner_page').css("display", "block");
		
      }
    };
    request.send();
  
	jQuery( ".wishlistbodycontainer" ).on( "click", ".product-form__submit", function() {
      //console.log("product-form__submit: true");
      //var vid = jQuery(this).data('variantid');
      
      if (partnerID != blush_partnerID) {
      	//console.log("cookie doesnt match page");
        jQuery(".current-artist").text( blush_swm.full_name );
        jQuery(".new-artist").text(partnerNameVariable);
        jQuery("#new-artist").attr("data-id", partnerID);
        //jQuery(".shop-with-compare-text a").attr("data-variantid", vid);
        jQuery(".shop-with-compare").css("display", "block");
      } //else {
        //console.log("vid: "+ vid);
        //addItemToCart( this, vid, 1, "1", "","reload");
        //return false;
      //}
  	});
   
  
  });
  
